module.exports = require('./helpers/bundle-url').getBundleURL('2lNV8') + "send-sms.d0d83d97.svg";